import awaitDynamics from '../general/await-dynamics';
import { DLFormStart, DLFormSubmit } from '../general/data-layer';
import populateUTMFields from '../general/populate-utm-fields';

const forms = document.querySelectorAll('.js-data-layer-form');

const handleForm = (form: HTMLElement) => {
  const data = JSON.parse(form.dataset.layerForm),
    { formName, formType, serviceLine, region } = data,
    isOptiForm = data.isOptiForm === 'True';

  const handleDataLayer = () => {
    DLFormSubmit({
      form_name: formName,
      form_type: formType.trim(),
      service_line: serviceLine,
      region,
    });
  };

  const handleFormStart = () => {
    const callback = () => {
      DLFormStart({
        form_name: formName,
        form_type: formType.trim(),
        service_line: serviceLine,
        region,
      });
      form.removeEventListener('click', callback);
    };

    form.addEventListener('click', callback);
  };

  if (isOptiForm && typeof $$epiforms !== 'undefined') {
    const formEl = form.querySelector('form');
    $$epiforms(formEl).on('formsSubmitted', handleDataLayer);
  } else {
        document.addEventListener("d365mkt-afterformload", function () {
            populateUTMFields();
        });
        document.addEventListener("d365mkt-afterformsubmit", function () {
            handleDataLayer();
        });
  }

  handleFormStart();
};

forms.forEach(handleForm);
